module.exports = __webpack_public_path__ + "static/img/google-logo.695a3160.svg";